import * as types from './mutation-types'

const namespaced = true

const initialState = {
    list: []
}

const mutations = {
    [types.PUT_ELECTION_MODELS](state, electionModels) {
        state.list = electionModels
    }
}

const actions = {
    async list(context, { raceId }) {
        await fetch(`https://forecasting-data.decisiondeskhq.com/2020/prod/races/${ raceId }.json`)
            .then(response => response.json())
            .then(data => {
                context.commit(types.PUT_ELECTION_MODELS, data);
            })
            .catch(error => console.error(error));
    },
}

const getters = {
    list(state) {
        return state.list
    }
}

export default {
    namespaced,
    state: initialState,
    mutations,
    actions,
    getters
}
